import type { ObjectGraph } from '@jet/environment/dependencies/object-graph';
import type { IntentController } from '@jet/environment/dispatching';
import { makeBrowseDetailPaginationIntent } from './BrowseDetailPaginationIntent';
import { IntentKind } from '@jet-app/music-classical/intents';
import type {
    PaginationResult,
    PaginationIntent,
} from '@jet-app/music-classical/intents/common/pagination-invalidation-intent';
import { requestViewPageWithQuery } from '@jet-app/music-classical/api/request-view-page';
import type { PageChangeInstruction } from '@jet-app/music-classical/models/invalidation/change-instruction/PageChangeInstruction';
import { NetworkError } from '@jet-app/music-classical/utilities';
import type {
    ClassicalListItem,
    ClassicalPaginatedResponse,
} from '@jet-app/music-classical/api/types';
import {
    getItemKindFromType,
    transformListScreenToGridView,
} from '../renderBrowseDetailPage';

export const BrowseDetailPaginationIntentController: IntentController<PaginationIntent> =
    {
        $intentKind: IntentKind.BROWSE_DETAIL_PAGINATION,
        async perform(
            intent: PaginationIntent,
            objectGraph: ObjectGraph,
        ): Promise<PaginationResult> {
            const apiResponse = await requestViewPageWithQuery(
                intent.url,
                objectGraph,
            );

            const result = apiResponse.body as ClassicalPaginatedResponse;

            if (!result) {
                throw NetworkError.noContent();
            }

            const newSections = transformListScreenToGridView(
                result.items as unknown as ClassicalListItem[],
                objectGraph,
            );
            const addItemsInstruction: PageChangeInstruction = {
                instruction: {
                    instruction: 'addItemsToSection',
                    newSectionToAppendItemsFrom: {
                        itemKind: getItemKindFromType(
                            newSections?.[0]?.items?.[0].type,
                        ),
                        id: intent.id,
                        items: newSections?.[0]?.items,
                    },
                },
            };

            return {
                nextIntent: result.next
                    ? makeBrowseDetailPaginationIntent({
                          url: result.next,
                          id: intent.id,
                      })
                    : null,
                pageChangeInstruction: addItemsInstruction,
            };
        },
    };
